// extracted by mini-css-extract-plugin
export default {"container":"author-image_container__202OK","picture":"author-image_picture__2JHSP","circle":"author-image_circle__3GaZ9","withoutCircle":"author-image_withoutCircle__d4NM4"};